<template>
  <tr>
    <td>{{index+1}}</td>
  	<td v-if="showCode">{{item.item_code}}</td>
    <td v-if="!isMobileApp">{{item.title}}</td>
    <td>{{item.unit_name}}</td>
    <td class="text-xs-right" v-if="showPrice">{{ item.rate | roundValue }}</td>
    <td class="text-xs-right">
      <span v-if="viewMode">{{ item.quantity }}</span>
      <v-edit-dialog v-else :return-value="quantity" lazy @open="open" @close="close"> {{ item.quantity }}
        <v-text-field type="number" :rules="quantityRules" slot="input" v-model="quantity" label="Enter Quantity" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td v-if="approveMode" class="text-xs-right">{{item.stock_quantity}}</td>
    <td class="text-xs-right" v-if="showPrice && showTax">{{ item.tax_percent }}</td>
    <td class="text-xs-right" v-if="showPrice">{{ item.total | roundValue }}</td>
    <td class="align-right justify-end layout px-2" v-if="!viewMode">
      <v-btn flat icon @click="$emit('delete', index)">
        <v-icon color="red">clear</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>

  export default {
    name: 'InvoiceItem' ,
    props: {
      item: {
        required: true
      },
      index: {
        required: true
      },
      viewMode: {
        default: false
      },
      approveMode: {
        default: false
      },
      showPrice: {
        default: true
      },
      showCode: {
        default: true
      },
      showTax: {
        default: true
      }
    },

    data () {
      return {
        quantity: 1,
        quantityRules: [
          v => !!v || 'Quantity is required',
          v => /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Quantity must be valid'
        ]
      }
    },
    
    methods: {
    	open () {
        this.quantity = this.item.quantity
      },
      close () {
        this.item.quantity = this.item.allow_decimal ? this.quantity : parseInt(this.quantity)
      }
    },

    mounted () {
    	this.item.total = this.item.quantity * ( this.item.rate + this.item.tax )
    },

    computed: {
      
      itemTotal () {
        return this.item.quantity * ( this.item.rate + this.item.tax )
      }

    },

    watch: {

      itemTotal (val) {
        this.item.total = val
      },
    	
      'item.quantity' (val, oldVal) {
    		if (!val || val <= 0) {
          this.item.quantity = 1
    		}
    	}
      
    }
    
  }

</script>
